// @ts-nocheck
import { createTheme as createMuiTheme } from "@material-ui/core/styles";
import { grey, red } from "@material-ui/core/colors";

// All the following keys are optional.
// We try our best to provide a great default value.
export const MuiTheme = createMuiTheme({
  palette: {
    primary: grey,
    secondary: {
      light: "#32325d",
      main: "#5566d6",
      // dark: will be calculated from palette.secondary.main,
      dark: "#02669f",
      contrastText: "#5f72e4"
    },
    common: {
      black: "#000",
      white: "#fff"
    },
    error: red,
    text: {
      primary: "rgba(50, 50, 93, 0.5)",
      secondary: "#32325d",
      hint: "#5566d6"
    },
    background: {
      paper: "#ffffff",
      default: "#f8f9ff"
    },
    contrastThreshold: 3,
    tonalOffset: 0.2
  },
  typography: {
    fontFamily: "'Open Sans', sans-serif !important",
    subtitle1: {
      fontSize: 12
    },
    body1: {
      fontWeight: 600,
      fontSize: 14
    },
    button: {
      fontSize: "12px",
      fontWeight: 500,
      fontStretch: "normal",
      fontStyle: "normal"
    }
  },
  overrides: {
    // Name of the component ⚛️ / style sheet
    // MuiButton: {
    //   root: {
    //     "&.$Mui-disabled": {
    //       color: "#32325d"
    //     },
    //     "&$hover": {
    //       background: "#3d55df !important"
    //     },
    //     textTransform: "none"
    //   },
    //   outlined: {
    //     textTransform: "none",
    //     backgroundColor: "#5f72e4 !important",
    //     border: "none !important",
    //     boxShadow: "0px 1px 1px 0 rgba(0, 0, 0, 0.26)",
    //     color: "#FFFFFF !important",
    //     "&:hover": {
    //       backgroundColor: "#3d55df !important",
    //     }
    //   },
    //   contained: {
    //     borderRadius: "7px",
    //     border: "none !important",
    //     // border: "solid 1px #0067a4",
    //     lineHeight: "1.57",
    //     letterSpacing: "0.53px",
    //     boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.22)",
    //     backgroundColor: "#ffffff !important",
    //     "&:hover": {
    //       backgroundColor: "#dfe1e6 !important",
    //     }
    //   }
    // },
    // MuiCssBaseline: {
    //   '@global': {
    //     fontFamily: "'Open Sans', sans-serif !important",
    //   },
    // },
    MuiPickersCalendarHeader: {
      iconButton: {
        backgroundColor: "none !important"
      },
      daysHeader: {
        color: "#32325d"
      },
      dayLabel: {
        color: "#32325d",
        fontWeight: 600
      }
    },
    MuiPickersDay: {
      day: {
        color: "#32325d"
      },
      daySelected: {
        backgroundColor: "#5e72e4",
        color: "#ffffff"
      },
      dayDisabled: {
        color: "#32325d"
      }
    },
    MuiAppBar: {
      colorDefault: {
        backgroundImage: "linear-gradient(93deg, #0fcbef 4%, #1071ee 90%)",
        // backgroundImage: "linear-gradient(90deg, #014DB0 55%, #009BC9 90%)",
        padding: "12px 12px 12px 17px",
        boxShadow: "none"
      }
    },
    MuiSvgIcon: {
      root: {
        // width: "13px",
        height: "16px"
        // color: "#7a8aa0"
      }
    },
    MuiFormControlLabel: {
      root: {
        "&.$Mui-disabled": {
          cursor: "no-drop !important"
        }
      }
    },
    MuiButton: {
      root: {
        textTransform: "none", // remove capitalization for all button
        fontWeight: 600
      },
      iconSizeMedium: {
        fontSize: "16px"
      },
      startIcon: {
        fontSize: "16px !important"
      },
      contained: {
        // default purple button
        backgroundColor: "#5f72e4",
        color: "#ffffff",
        "&:active": {
          boxShadow: "none"
        },
        "&:hover": {
          backgroundColor: "#3d55df",
          "&.$Mui-disabled": {
            backgroundColor: "#5f72e4"
          }
        },
        "&.$Mui-disabled": {
          backgroundColor: "#5f72e4",
          color: "#ffffff !important",
          pointerEvents: "unset !important",
          opacity: "0.5",
          "&:hover": {
            cursor: "no-drop",
            backgroundColor: "#5f72e4"
          }
        }
      },
      containedPrimary: {
        // white button
        backgroundColor: "#ffffff",
        margin: "0px 10px 0px 0px",
        color: "#32325d",
        "&:hover": {
          backgroundColor: "#dfe1e6"
        },
        "&.$Mui-disabled": {
          backgroundColor: "#dfe1e6",
          color: "#32325d !important",
          opacity: "0.5",
          pointerEvents: "unset !important"
        }
      },
      containedSecondary: {
        // green button
        backgroundColor: "#2ece89",
        color: "#ffffff",
        "&:hover": {
          backgroundColor: "#29ae74"
        },
        "&.$Mui-disabled": {
          backgroundColor: "#29ae74",
          color: "#ffffff !important",
          opacity: "0.5",
          pointerEvents: "unset !important"
        }
      },
      text: {
        color: "#32325d",
        padding: "0",
        "&:active": {
          color: "#3d55df"
        },
        "&:hover": {
          color: "#5e72e4",
          background: "none"
        }
      }
    },
    MuiSelect: {
      root: {
        // fontWeight: 600,
      },
      select: {
        color: "#32325d",
        "&:focus": {
          borderRadius: 3,
          backgroundColor: "#f7f9fc !important",
          margin: "-3px",
          marginBottom: "0 !important"
        },
        "&:selected": {
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04) !important"
          }
        }
      }
    },
    MuiBadge: {
      anchorOriginTopRightCircle: {
        background: "#FFF",
        transform: "scale(0.8) translate(30%, -20%)"
      },
      badge: {
        width: "23px !important",
        height: "23px !important",
        borderRadius: "23px",
        lineHeight: 23
      }
    },
    MuiList: {
      root: {
        minWidth: "100px"
      }
    },
    MuiMenuItem: {
      root: {
        whiteSpace: "break-spaces",
        fontWeight: 500,
        "&:hover": {
          fontWeight: 600
        }
      }
    },
    MuiListItem: {
      root: {
        "&.$Mui-selected": {
          fontWeight: 600,
          backgroundColor: "#f8f9ff !important",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04) !important"
          }
        },
        "&.$Mui-focusVisible": {
          backgroundColor: "rgba(0, 0, 0, 0.04)"
        }
      }
    },
    // MuiTypography: {
    //   root: {
    //     fontSize: "12px !important"
    //   }
    // },
    MuiCheckbox: {
      root: {
        color: "#7a8aa0",
        width: "20px",
        padding: "0px 10px 0px 0px",
        "&$checked": {
          color: "#5e72e4 !important"
        }
      }
    },
    MuiInputLabel: {
      outlined: {
        letterSpacing: "normal",
        color: "#363b41"
      },
      formControl: {
        transform: "none !important"
      }
    },
    MuiInputBase: {
      root: {
        "&:focus": {
          borderRadius: "4px"
          // border: "1px solid #5e72e4 !important"
        }
      },
      input: {
        padding: "10px",
        "&:focus": {
          borderRadius: "4px"
          // border: "1px solid #5e72e4 !important"
        }
      }
    },
    MuiRadio: {
      root: {
        color: "#02669f",
        "&$checked": {
          color: "#02669f"
        }
      }
    },
    MuiOutlinedInput: {
      root: {
        "& $notchedOutline": {
          borderColor: "#cad1d7",
          borderWidth: 1
        }
      }
    },
    MuiInput: {
      root: {
        borderBottom: "1px solid transparent"
      },
      underline: {
        "&&&&:before": {
          borderBottom: "1px solid transparent"
        },
        "&&&&:after": {
          borderBottom: "1px solid transparent"
        },
        "&&&&:hover:before": {
          borderBottom: "1px solid transparent"
        },
        "&&&&:hover:after": {
          borderBottom: "1px solid transparent"
        }
      }
    },
    MuiTab: {
      root: {
        minWidth: "110px !important",
        "&$disabled": {
          color: "#fff"
        }
      },
      textColorPrimary: {
        "&$selected": {
          color: "#02669f",
          fontWeight: "bold"
        }
      },
      textColorSecondary: {
        color: "#FFF",
        "&$selected": {
          color: "#fff",
          fontWeight: "bold"
        },
        "&$disabled": {
          color: "#ffffff"
        }
      }
    },
    MuiTableHead: {
      root: {
        color: "#424242",
        background: "#eef6ff",
        fontSize: "12px"
      }
    },
    MuiTableCell: {
      root: {
        padding: "0px"
      },
      head: {
        color: "#424242",
        padding: "10px 0px 7px 8px",
        fontSize: "12px"
      },
      body: {
        color: "#424242",
        fontSize: "12px",
        padding: "7px 0px 8px 8px "
      }
    },
    MuiTablePagination: {
      root: {
        color: "#424242"
      }
    },
    MuiPaper: {
      root: {
        color: "#424242",
        backgroundColor: "#FFF"
        // marginTop: "50px",
        // minWidth: "365px !important",
        // "@media (max-width: 1024px)": {
        //   minWidth: "279px !important"
        // },
        // "@media (max-width: 768px)": {
        //   minWidth: "307px !important"
        // }
      }
    },
    MuiTableSortLabel: {
      root: {
        color: "#424242",
        "&$active": {
          color: "#424242"
        }
      }
    }
  },
  props: {
    MuiButtonBase: {
      disableRipple: true // No more ripple, on the whole application!
    }
  }
});
